import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "@/components/AuthProvider";


export const ProtectedRoute = () => {
  const { isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <main className="app-loading" data-testid="session-loading" role="status">
        Memeriksa sesi aman…
      </main>
    );
  }

  if (!user) {
    return <Navigate replace to="/login" />;
  }

  return <Outlet />;
};